const enviroment = {
  baseURL: "http://localhost:3333/api",
};

export default enviroment;
